<template>
  <v-app id="app_user_role_list">

    <v-overlay v-model="centerLoading" :scrim="false" class="centered-overlay">
      <v-progress-circular color="green" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">USER ROLES</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">User roles & their permissions registered in the
            system.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-btn color="#800080" size="x-large" variant="text" @click="createUser()">
              <v-icon>mdi-plus-circle</v-icon>&nbsp;&nbsp;CREATE USER
            </v-btn>
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class=" custom_pdf_btn" variant="outlined" @click="exportPDF">
            <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel">
            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
          </v-btn>
        </v-card-text>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete v-model="userCatagory" :items="userCatagaryItems" clearable item-title="name"
                item-value="name" label="User Category" multiple placeholder="User Type" variant="outlined"
                density="comfortable" class="custom_input_field_color"></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete v-model="userRoleTypeFilter" :items="userTypes" clearable item-title="name"
                item-value="name" label="User Role Type" multiple placeholder="User Type" variant="outlined"
                density="comfortable" class="custom_input_field_color"></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" clearable hide-details label="Search"
                placeholder="Search" variant="outlined" density="comfortable"
                class="custom_input_field_color"></v-text-field>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-data-table :headers="headers" :loading="loading" :items="filteredItems" class="custom_table_normal"
            item-value="name">
            <template v-slot:[`item.category`]="{ item }">
              <span :class="['category-text', { 'super-admin-row-fade': isSuperAdminRole(item.role_type) }]">
                {{ formatCategoryDisplay(item.category) }}
              </span>
            </template>

            <template v-slot:[`item.role_type`]="{ item }">
              <span :class="['red-text', { 'super-admin-role-text': isSuperAdminRole(item.role_type) }]">
                {{ item.role_type }}
              </span>
            </template>

            <template v-slot:[`item.description`]="{ item }">
              <span :class="['description-text', { 'super-admin-row-fade': isSuperAdminRole(item.role_type) }]">{{
                item.description }}</span>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              <span :class="{ 'super-admin-row-fade': isSuperAdminRole(item.role_type) }">{{ new
                Date(item.created_at).toISOString().split('T')[0] }}</span>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_user_role_list">
                <template v-slot:activator="{ props }">
                  <v-btn style="background-color: #800080; color: white;"
                    v-if="permissions.delete || permissions.write || permissions.read"
                    :class="{ 'super-admin-row-fade': isSuperAdminRole(item.role_type) }" variant="flat" size="large"
                    v-bind="props">
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="permissions.read" @click="openViewDialog(item)">
                    <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.write && !isSuperAdminRole(item.role_type)"
                    @click="openEditDialog(item)">
                    <v-list-item-title class="custom_font_color_edit">EDIT</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="isSuperAdminRole(item.role_type)" disabled>
                    <v-list-item-title class="super-admin-locked-text">SUPER ADMIN ACCESS LOCKED</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="permissions.delete && !isSuperAdminRole(item.role_type)"
                    @click="confirmDelete(item)">
                    <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- ==================== VIEW USER ROLE DIALOG (Matches Edit Dialog Layout) ==================== -->
      <v-dialog v-model="view_user_role_dialog" id="app_user_role_list" fullscreen>
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
            class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn variant="flat" style="background-color: #800080; color: white;"
              @click="view_user_role_dialog = false">
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-14 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">VIEW USER ROLE</v-card-title>
                </template>
              </v-card>

              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="9" md="9" lg="9"></v-col>

                  <!-- Action Buttons in View Dialog - Just like in view user -->
                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-0 mr-3">
                      <v-spacer></v-spacer>
                      <!-- EDIT BUTTON - Only show if write permission exists -->
                      <v-btn v-if="permissions.write && !isSuperAdminRole(viewItem.role_type)"
                        class="mr-3 custom_edit_btn" icon rounded size="small" variant="outlined"
                        @click="openEditDialogFromView()">
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip activator="parent" location="top">Edit</v-tooltip>
                      </v-btn>

                      <!-- DELETE BUTTON - Only show if delete permission exists -->
                      <v-btn v-if="permissions.delete && !isSuperAdminRole(viewItem.role_type)"
                        class="custom_delete_btn" icon rounded size="small" variant="outlined"
                        @click="confirmDeleteFromView()">
                        <v-icon>mdi-trash-can</v-icon>
                        <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                      </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-2"></v-divider>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <v-alert color="#F0F0F0" prominent density="default" border="border-lg"
                          text="These user roles help you grant permissions and assign related functions to users in the system.">
                          <template v-slot:prepend>
                            <v-icon color="orange" size="x-large">mdi-alert</v-icon>
                          </template>
                        </v-alert>
                      </v-col>

                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <p class="custom_page_main_sub_title">
                          <strong>SELECT USER CATEGORY</strong>
                        </p>
                        <v-divider class="mt-4"></v-divider>
                      </v-col>

                      <v-col cols="6">
                        <v-checkbox :model-value="isWebUserSelectedForView" color="#800080" hide-details
                          label="WEB USER" rounded disabled></v-checkbox>
                      </v-col>

                      <v-col cols="6">
                        <v-checkbox :model-value="isMobileUserSelectedForView" color="#800080" hide-details
                          label="MOBILE USER" disabled></v-checkbox>
                      </v-col>

                      <v-col cols="6">
                        <v-checkbox :model-value="isBothSelectedForView" color="#800080" hide-details
                          label="WEB & MOBILE USER" disabled />
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-text-field :model-value="viewItem.role_type" label="Role type *"
                      placeholder="Type User Role Here" variant="outlined" density="comfortable" color="black" readonly
                      bg-color="#f5f5f5"></v-text-field>

                    <v-textarea :model-value="viewItem.description" class="mt-2" label="Description *"
                      placeholder="Type user description here" required rows="6" variant="outlined" color="black"
                      readonly bg-color="#f5f5f5"></v-textarea>
                  </v-col>
                </v-row>

                <!-- ===== VIEW PERMISSIONS (HIERARCHICAL) - SHOW ONLY FOR WEB USERS ===== -->
                <v-row class="ma-0 mt-4" v-if="shouldShowViewPermissions()">
                  <v-col cols="12">
                    <v-expansion-panels variant="accordion" class="custom_card_box" elevation="0">
                      <v-expansion-panel>
                        <v-expansion-panel-title>
                          <span class="font-weight-bold">User Permissions</span>
                        </v-expansion-panel-title>

                        <v-expansion-panel-text>
                          <v-card class="custom_card_box" elevation="0" border="sm opacity-1" rounded="lg">
                            <v-card-text class="pa-0">
                              <div class="permissions-table" :key="`view-perm-${viewItem.id || 'view'}`">
                                <div class="permissions-head">
                                  <div class="col-name">Module</div>
                                  <div class="col-perm">Read</div>
                                  <div class="col-perm">Write</div>
                                  <div class="col-perm">Delete</div>
                                </div>

                                <!-- LOOP THROUGH ITEMS FOR VIEW -->
                                <div v-for="item in viewPermissionsItems" :key="item.key">

                                  <!-- TYPE: SINGLE (Main component with access) -->
                                  <div v-if="item.type === 'single'" class="permissions-row">
                                    <div class="col-name d-flex align-center">
                                      <span class="font-weight-medium">{{ item.title }} <b>(Main)</b></span>
                                    </div>
                                    <div class="col-perm">
                                      <v-icon :color="item.permissions.read ? '#4CAF50' : '#9E9E9E'" size="small">
                                        {{ item.permissions.read ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                      </v-icon>
                                    </div>
                                    <div class="col-perm">
                                      <v-icon :color="item.permissions.write ? '#4CAF50' : '#9E9E9E'" size="small">
                                        {{ item.permissions.write ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                      </v-icon>
                                    </div>
                                    <div class="col-perm">
                                      <v-icon :color="item.permissions.delete ? '#4CAF50' : '#9E9E9E'" size="small">
                                        {{ item.permissions.delete ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                      </v-icon>
                                    </div>
                                  </div>

                                  <!-- TYPE: GROUP (Header only, children have access) -->
                                  <template v-else-if="item.type === 'group'">
                                    <!-- Header Row -->
                                    <div class="permissions-row" style="background-color: #f9f9f9;">
                                      <div class="col-name d-flex align-center">
                                        <span class="font-weight-bold text-uppercase" style="color:#05146F;">{{
                                          item.title }}</span>
                                      </div>
                                      <div class="col-perm"></div>
                                      <div class="col-perm"></div>
                                      <div class="col-perm"></div>
                                    </div>

                                    <!-- Child Rows -->
                                    <div v-for="child in item.children" :key="child.key" class="permissions-row"
                                      style="border-bottom: 1px dotted #e0e0e0;">
                                      <div class="col-name d-flex align-center pl-8">
                                        <span>{{ child.title }}</span>
                                      </div>
                                      <div class="col-perm">
                                        <v-icon :color="child.permissions.read ? '#4CAF50' : '#9E9E9E'" size="small">
                                          {{ child.permissions.read ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                        </v-icon>
                                      </div>
                                      <div class="col-perm">
                                        <v-icon :color="child.permissions.write ? '#4CAF50' : '#9E9E9E'" size="small">
                                          {{ child.permissions.write ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                        </v-icon>
                                      </div>
                                      <div class="col-perm">
                                        <v-icon :color="child.permissions.delete ? '#4CAF50' : '#9E9E9E'" size="small">
                                          {{ child.permissions.delete ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                        </v-icon>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                                <!-- END LOOP -->

                              </div>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>

                <!-- Message for Mobile Only Users -->
                <v-row class="ma-0 mt-4" v-else-if="!shouldShowViewPermissions() && viewItem.category">
                  <v-col cols="12">
                    <v-alert type="info" variant="tonal" density="comfortable">
                      <template v-slot:prepend>
                        <v-icon color="#2196F3">mdi-information</v-icon>
                      </template>
                      <div>
                        <strong>Mobile User Role</strong><br>
                        Mobile users do not have specific module permissions. They only have access to mobile-specific
                        features through the mobile application.
                      </div>
                    </v-alert>
                  </v-col>
                </v-row>
                <!-- ===== END VIEW PERMISSIONS ===== -->

              </v-card>

            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- Edit user role dialog -->
      <v-dialog v-model="edit_user_role_dialog" id="app_user_role_list" fullscreen>
        <v-card>
          <v-toolbar style="border-radius: 0px !important;"
            class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')"
                @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn variant="flat" style="background-color: #800080; color: white;"
              @click="edit_user_role_dialog = false">
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-14  custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPDATE USER ROLE</v-card-title>
                </template>
              </v-card>

              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="9" md="9" lg="9"></v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-0 mr-3">
                      <v-spacer></v-spacer>
                      <v-btn size="large" variant="flat" color="#800080"
                        style="background-color: #800080; color: white;"
                        :disabled="isSuperAdminRole(selectedItem.role_type || roleForm.roleType)"
                        @click="updateUserRole">
                        Update User Role
                      </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-2"></v-divider>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <v-alert color="#F0F0F0" prominent density="default" border="border-lg"
                          text="These user roles help you grant permissions and assign related functions to users in the system.">
                          <template v-slot:prepend>
                            <v-icon color="orange" size="x-large">mdi-alert</v-icon>
                          </template>
                        </v-alert>
                      </v-col>

                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <p class="custom_page_main_sub_title">
                          <strong>SELECT USER CATEGORY</strong>
                        </p>
                        <v-divider class="mt-4"></v-divider>
                      </v-col>

                      <v-col cols="6">
                        <v-checkbox v-model="selectedUser" :value="'Web User'" color="#800080" hide-details
                          label="WEB USER" rounded></v-checkbox>
                      </v-col>

                      <v-col cols="6">
                        <v-checkbox v-model="selectedUser" :value="'Mobile User'" color="#800080" hide-details
                          label="MOBILE USER"></v-checkbox>
                      </v-col>

                      <v-col cols="6">
                        <v-checkbox :model-value="isBothSelectedEdit" @update:model-value="toggleBothEdit"
                          color="#800080" hide-details label="WEB & MOBILE USER" />
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-text-field v-model="roleForm.roleType" :items="userTypes" label="Role type *"
                      placeholder="Type User Role Here" variant="outlined" density="comfortable" color="black"
                      :counter="20" maxlength="20" :rules="roleTypeRules"></v-text-field>

                    <v-textarea v-model="roleForm.description" class="mt-2" label="Description *"
                      placeholder="Type user description here" required rows="6" variant="outlined" color="black"
                      :counter="300" maxlength="300" :rules="descriptionRules"></v-textarea>
                  </v-col>
                </v-row>

                <!-- ===== EDIT PERMISSIONS (HIERARCHICAL) - SHOW ONLY FOR WEB USERS ===== -->
                <v-row class="ma-0 mt-4" v-if="shouldShowPermissions()">
                  <v-col cols="12">
                    <v-expansion-panels variant="accordion" class="custom_card_box" elevation="0">
                      <v-expansion-panel>
                        <v-expansion-panel-title>
                          <span class="font-weight-bold">User Permissions</span>
                        </v-expansion-panel-title>

                        <v-expansion-panel-text>
                          <v-card class="custom_card_box" elevation="0" border="sm opacity-1" rounded="lg">
                            <v-card-text class="pa-0">
                              <div class="permissions-table" :key="`perm-${selectedItem.id || 'new'}`">
                                <div class="permissions-head">
                                  <div class="col-name">Module</div>
                                  <div class="col-perm">Read</div>
                                  <div class="col-perm">Write</div>
                                  <div class="col-perm">Delete</div>
                                </div>

                                <!-- LOOP THROUGH ITEMS -->
                                <div v-for="item in editPermissionsItems" :key="item.key">

                                  <!-- TYPE: SINGLE (Main component with access) -->
                                  <div v-if="item.type === 'single'" class="permissions-row">
                                    <div class="col-name d-flex align-center">
                                      <span class="font-weight-medium">{{ item.title }} <b>(Main)</b></span>
                                    </div>
                                    <div class="col-perm">
                                      <v-checkbox-btn v-model="item.permissions.read" class="checkbox" color="#800080"
                                        @update:model-value="handleEditPermissionChange(item, 'read')" />
                                    </div>
                                    <div class="col-perm">
                                      <v-checkbox-btn v-model="item.permissions.write" class="checkbox" color="#800080"
                                        @update:model-value="handleEditPermissionChange(item, 'write')" />
                                    </div>
                                    <div class="col-perm">
                                      <v-checkbox-btn v-model="item.permissions.delete" class="checkbox" color="#800080"
                                        @update:model-value="handleEditPermissionChange(item, 'delete')" />
                                    </div>
                                  </div>

                                  <!-- TYPE: GROUP (Header only, children have access) -->
                                  <template v-else-if="item.type === 'group'">
                                    <!-- Header Row -->
                                    <div class="permissions-row" style="background-color: #f9f9f9;">
                                      <div class="col-name d-flex align-center">
                                        <span class="font-weight-bold text-uppercase" style="color:#05146F;">{{
                                          item.title }}</span>
                                      </div>
                                      <div class="col-perm"></div>
                                      <div class="col-perm"></div>
                                      <div class="col-perm"></div>
                                    </div>

                                    <!-- Child Rows -->
                                    <div v-for="child in item.children" :key="child.key" class="permissions-row"
                                      style="border-bottom: 1px dotted #e0e0e0;">
                                      <div class="col-name d-flex align-center pl-8">
                                        <!-- Indented child title -->
                                        <span>{{ child.title }}</span>
                                      </div>

                                      <div class="col-perm">
                                        <v-checkbox-btn v-model="child.permissions.read" class="checkbox"
                                          color="#800080"
                                          @update:model-value="handleEditPermissionChange(child, 'read')" />
                                      </div>

                                      <div class="col-perm">
                                        <v-checkbox-btn v-model="child.permissions.write" class="checkbox"
                                          color="#800080"
                                          @update:model-value="handleEditPermissionChange(child, 'write')" />
                                      </div>

                                      <div class="col-perm">
                                        <v-checkbox-btn v-model="child.permissions.delete" class="checkbox"
                                          color="#800080"
                                          @update:model-value="handleEditPermissionChange(child, 'delete')" />
                                      </div>
                                    </div>
                                  </template>
                                </div>
                                <!-- END LOOP -->

                              </div>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
                <!-- ===== END EDIT PERMISSIONS ===== -->

              </v-card>

            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- Delete product confirmation dialog -->
      <v-dialog v-model="deleteUserListDialog" id="app_user_role_list" max-height="600" max-width="600" persistent>
        <v-card id="app_product_list" rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE USER ROLE</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="deleteUserListDialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this user role ?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This user role will be deleted immediately. Once deleted, it can no longer be used in any purpose.
                </p>

                <p class="text-body-2 mt-2 text-justify"
                  style="color: #1976D2; font-weight: 500; background-color: #E3F2FD; padding: 12px; border-radius: 4px; border-left: 4px solid #1976D2;">
                  <v-icon color="#1976D2" size="small" class="mr-1">mdi-information</v-icon>
                  Further, this module are also related to the following other module also, so please read & confirm
                  before
                  deleting this.
                </p>

                <!-- Show user role details before deletion -->
                <v-divider class="mt-4"></v-divider>

                <div class="mt-4">
                  <p class="font-weight-bold text-subtitle-2">User Role Details:</p>
                  <v-table density="compact" class="mt-2">
                    <tbody>
                      <tr>
                        <td class="font-weight-bold">Role Type:</td>
                        <td>{{ selectedItem.role_type || 'N/A' }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Category:</td>
                        <td>{{ selectedItem.category || 'N/A' }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Description:</td>
                        <td>{{ selectedItem.description || 'N/A' }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Created Date:</td>
                        <td>{{ selectedItem.created_at ? new Date(selectedItem.created_at).toISOString().split('T')[0] :
                          'N/A'
                          }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Permissions Count:</td>
                        <td>{{ getPermissionsCount(selectedItem) }}</td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>

                <!-- Show warning if role has associated users -->
                <v-alert v-if="hasAssociatedUsers(selectedItem)" type="warning" variant="tonal" class="mt-4"
                  density="compact">
                  <strong>Warning:</strong> This role has {{ getAssociatedUsersCount(selectedItem) }} associated
                  user(s).
                  Deleting it may affect their access.
                </v-alert>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4 ">
                  <v-btn class="custom_btn_primary" @click="deleteItem">DELETE</v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="deleteUserListDialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
        :top="snackAlert.snackBarTop" location="top right" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import { getPermissions } from "@/plugins/permissions";

export default {
  name: 'UserRoleList',
  data() {
    return {
      centerLoading: false,
      search: '',
      headers: [
        { text: 'USER CATEGORY', value: 'category', title: 'USER CATEGORY', width: '15%' },
        { text: 'Role Type', value: 'role_type', title: 'Role Type', width: '18%' },
        { text: 'Creation Date', value: 'created_at', title: 'Creation Date', width: '12%' },
        { text: 'Description', value: 'description', title: 'Description', width: '35%' },
        { text: 'Action', value: 'action', sortable: false, title: 'Action', width: '20%' }
      ],
      userCatagory: '',
      userCatagaryItems: ['Web', 'Mob', 'Web & Mobile'],
      userTypesItem: [],
      userRoleTypeFilter: '',
      isEditMode: false,
      roleForm: {
        id: null,
        roleType: '',
        description: '',
        permissions: [],
        dashboard: []
      },
      items: [],
      selectedUser: "",
      relatedValue: null,
      itemsPerPage: 10,
      page: 1,
      totalPages: 0,
      deleteUserListDialog: false,
      edit_user_role_dialog: false,
      view_user_role_dialog: false,
      roleToDelete: null,
      userRoles: [],
      userTypes: [],
      selectedItem: {
        id: null,
        user_role_id: null,
        description: '',
        dashboard: [],
        category: '',
        role_type: '',
        created_at: null
      },
      viewItem: {
        id: null,
        role_type: '',
        description: '',
        category: '',
        created_at: null,
        accessDashboard: []
      },
      loading: false,
      deleteItemId: null,
      permissionsItems: [],
      permissions: {},
      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarRight: false,
        snackBarTop: true,
      },
      associatedUsersCount: {},

      // Validation rules
      roleTypeRules: [
        v => !!v || 'Role type is required',
        v => (v && v.length <= 20) || 'Role type must be less than or equal to 20 characters',
        v => (v && /^[a-zA-Z0-9\s\-_]+$/.test(v)) || 'Role type can only contain letters, numbers, spaces, hyphens and underscores'
      ],
      descriptionRules: [
        v => !!v || 'Description is required',
        v => (v && v.length <= 300) || 'Description must be less than or equal to 300 characters'
      ],

      // ===== MAIN NAV MODULES HIERARCHY (ALL CHECKBOXES ENABLED) =====
      mainNavModules: [
        // --- Single Access Main Components ---
        {
          key: "dashboard",
          title: "Dashboard",
          dashboard_id: 1,
          type: "single"
        },
        {
          key: "area",
          title: "Area Management",
          dashboard_id: 4,
          type: "single"
        },
        {
          key: "dailySummary",
          title: "Daily Summary Report",
          dashboard_id: 11,
          type: "single"
        },
        {
          key: "userLogs",
          title: "User Logs",
          dashboard_id: 12,
          type: "single"
        },

        // --- Group Components with Sub Component IDs ---
        {
          key: "lead",
          title: "New Visit Management",
          dashboard_id: 2,
          type: "group",
          children: [
            { key: "add_leads", title: "Add New Visit", dashboard_id: 2 },
            { key: "lead_list", title: "New Visit List", dashboard_id: 2 },
            { key: "leads_approval", title: "New Visit for Approval", dashboard_id: 2 },
            { key: "approved_leads", title: "Approved New Visit", dashboard_id: 2 },
            { key: "rejected_leads", title: "Rejected New Visit", dashboard_id: 2 },
          ],
        },
        {
          key: "user",
          title: "User Management",
          dashboard_id: 3,
          type: "group",
          children: [
            { key: "user_registration", title: "User Registration", dashboard_id: 3 },
            { key: "user_list", title: "User List", dashboard_id: 3 },
            { key: "create_user_role", title: "Create User Role", dashboard_id: 3 },
            { key: "user_role_list", title: "User Role List", dashboard_id: 3 },
          ],
        },
        {
          key: "dealer",
          title: "Dealer Management",
          dashboard_id: 5,
          type: "group",
          children: [
            { key: "dealer_management", title: "Dealer Registration", dashboard_id: 5 },
            { key: "dealer_list", title: "Dealer List", dashboard_id: 5 },
          ],
        },
        {
          key: "product",
          title: "Product Management",
          dashboard_id: 6,
          type: "group",
          children: [
            { key: "add_product", title: "Add Product", dashboard_id: 6 },
            { key: "product_list", title: "Product List", dashboard_id: 6 },
            { key: "add_category", title: "Add Category", dashboard_id: 6 },
            { key: "category_list", title: "Category List", dashboard_id: 6 },
          ],
        },
        {
          key: "route",
          title: "Route Management",
          dashboard_id: 7,
          type: "group",
          children: [
            { key: "create_routes", title: "Create Routes", dashboard_id: 7 },
            { key: "routes_list", title: "Routes List", dashboard_id: 7 },
          ],
        },
        {
          key: "collection",
          title: "Collection Management",
          dashboard_id: 8,
          type: "group",
          children: [
            { key: "collection_bulk_upload", title: "Collection Bulk Upload", dashboard_id: 8 },
            { key: "total_collection", title: "Total Collection", dashboard_id: 8 },
            { key: "overdue_collection", title: "Overdue Collection", dashboard_id: 8 },
            { key: "approved_overdues", title: "Approved Overdues", dashboard_id: 8 },
            { key: "CollectionNotify", title: "Collection Notify List", dashboard_id: 8 },
          ],
        },
        {
          key: "tracking",
          title: "Tracking Management",
          dashboard_id: 9,
          type: "group",
          children: [
            { key: "live_tracking", title: "Live Tracking", dashboard_id: 9 },
            { key: "tracking_history", title: "Tracking History", dashboard_id: 9 },
          ],
        },
        {
          key: "bulkUpload",
          title: "BulkUpload Management",
          dashboard_id: 13,
          type: "group",
          children: [
            { key: "Bulk_Upload", title: "Bulk Upload", dashboard_id: 13 },
          ],
        },
        {
          key: "paymentReversal",
          title: "Payment Reversal",
          dashboard_id: 10,
          type: "group",
          children: [
            { key: "pending_reversals", title: "Pending Reversals", dashboard_id: 10 },
            { key: "approved_reversals", title: "Approved Reversals", dashboard_id: 10 },
          ],
        },
      ],

      editPermissionsItems: [],
      viewPermissionsItems: [],
    };
  },

  mounted() {
    const dashboardId = 3;
    this.permissions = getPermissions(dashboardId);
    console.log("Permissions:", this.permissions);
    this.getAllUserRoles();
    this.getDashboardPermissions();
    this.fetchAssociatedUsersCount();
  },

  created() {
    this.fetchUserRoles();
  },

  computed: {
    filteredItems() {
      const query = this.search ? this.search.toLowerCase() : '';
      const selectedCategories = this.userCatagory || [];
      const selectedRoles = this.userRoleTypeFilter || [];

      return this.items.filter((item) => {
        const formattedCategory = this.formatCategoryDisplay(item.category);

        const matchesQuery = query
          ? Object.keys(item).some((key) =>
            String(item[key] || '').toLowerCase().includes(query)
          ) || formattedCategory.toLowerCase().includes(query)
          : true;

        const matchesCategory =
          selectedCategories.length === 0 ||
          selectedCategories.includes(formattedCategory);

        const matchesRole =
          selectedRoles.length === 0 ||
          selectedRoles.includes(item.role_type);

        return matchesQuery && matchesCategory && matchesRole;
      });
    },

    isBothSelectedEdit() {
      const arr = Array.isArray(this.selectedUser) ? this.selectedUser : [this.selectedUser].filter(Boolean);
      return arr.includes('Web User') && arr.includes('Mobile User');
    },

    // View dialog computed properties for checkboxes
    isWebUserSelectedForView() {
      const category = String(this.viewItem.category || '');
      return category.includes('Web User');
    },

    isMobileUserSelectedForView() {
      const category = String(this.viewItem.category || '');
      return category.includes('Mobile User');
    },

    isBothSelectedForView() {
      const category = String(this.viewItem.category || '');
      return category.includes('Web User') && category.includes('Mobile User');
    }
  },

  methods: {
    formatCategoryDisplay(category) {
      if (!category) return 'N/A';
      if (category.includes('Web User') && category.includes('Mobile User')) {
        return 'Web & Mobile';
      } else if (category.includes('Web User')) {
        return 'Web';
      } else if (category.includes('Mobile User')) {
        return 'Mob';
      }
      return category;
    },

    shouldShowViewPermissions() {
      const category = String(this.viewItem.category || '');
      return category.includes('Web User');
    },

    shouldShowPermissions() {
      const categories = Array.isArray(this.selectedUser)
        ? this.selectedUser
        : [this.selectedUser].filter(Boolean);
      return categories.includes('Web User');
    },

    extractTableRow(row) {
      return row && row.raw ? row.raw : row;
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    normalizeRoleName(roleName) {
      return String(roleName || '').trim().toLowerCase().replace(/\s+/g, ' ');
    },

    isSuperAdminRole(roleName) {
      const normalized = this.normalizeRoleName(roleName);
      return normalized === 'super admin' || normalized === 'superadmin';
    },

    getPermissionsCount(item) {
      if (!item || !item.accessDashboard) return 0;
      return item.accessDashboard.length || 0;
    },

    hasAssociatedUsers(item) {
      if (!item || !item.id) return false;
      return (this.associatedUsersCount[item.id] || 0) > 0;
    },

    getAssociatedUsersCount(item) {
      if (!item || !item.id) return 0;
      return this.associatedUsersCount[item.id] || 0;
    },

    async fetchAssociatedUsersCount() {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('/api/user-roles/users-count', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (response.data.success) {
          this.associatedUsersCount = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching associated users count:', error);
      }
    },

    exportExcel() {
      const worksheet = XLSX.utils.json_to_sheet(
        this.filteredItems.map(item => ({
          'User Category': this.formatCategoryDisplay(item.category) || 'N/A',
          'Role Type': item.role_type || 'N/A',
          'Creation Date': new Date(item.created_at).toISOString().split('T')[0],
          'Description': item.description || 'N/A'
        }))
      );

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'User Roles');
      XLSX.writeFile(workbook, 'User_Role_List.xlsx');

      this.logDocumentDownload('User_Role_List.xlsx', 'excel');
    },

    exportPDF() {
      const doc = new jsPDF();

      // Set title - matching User List style
      doc.setFontSize(16);
      doc.text('User Role List Report', 14, 20);
      doc.setFontSize(10);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

      // Define columns - matching User List table structure
      const tableColumn = [
        'User Category',
        'Role Type',
        'Creation Date',
        'Description'
      ];

      const tableRows = this.filteredItems.map(item => [
        this.formatCategoryDisplay(item.category) || 'N/A',
        item.role_type || 'N/A',
        new Date(item.created_at).toISOString().split('T')[0],
        item.description || 'N/A'
      ]);

      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 40,
        theme: 'grid',
        headStyles: {
          fillColor: [128, 0, 128], // Using #800080 purple - matching User List
          textColor: [255, 255, 255],
          fontSize: 8
        },
        bodyStyles: {
          fontSize: 7
        }
      });

      doc.save('User_Role_List.pdf');
      this.logDocumentDownload('User_Role_List.pdf', 'pdf');
    },

    async logDocumentDownload(fileName, file_type) {
      console.log(fileName);
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!userId) {
          throw new Error('User ID not found');
        }

        const response = await axios.post(`/api/log-document-download`, {
          user_id: userId,
          file_type: file_type,
          file_name: fileName,
          entity_area: 'User Management',
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status !== 200) {
          throw new Error('Failed to log download');
        }

        console.log('Download logged successfully');
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },

    getDashboardPermissions() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.post(`/api/getDashboard?userId=${userId}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
        .then(response => {
          const dashboards = response.data.data;
          this.permissionsItems = dashboards.map(dashboard => ({
            id: dashboard.id,
            premission_dashboard: dashboard.premission_dashboard,
            isOn: false,
            permissions: { read: false, write: false, delete: false },
          }));
          console.log('Dashboard permissions:', this.permissionsItems);
        })
        .catch(error => {
          console.error('Error fetching dashboard permissions:', error);
        });
    },

    getAllUserRoles() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.post('/api/getUserRolesType', {
        userId: userId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
        .then(response => {
          let usrRole = response.data.data;
          this.userTypes = usrRole.map(item => {
            return {
              id: item.id,
              name: item.role_type
            };
          });
          console.log('User role types:', this.userTypes);
        })
        .catch(error => {
          console.error('Error fetching user roles:', error);
        });
    },

    async fetchUserRoles() {
      this.loading = true;
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post('/api/allCreatedUserRoles', {
          userId: userId
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (response.data.success === "Get Dashboard successfully") {
          const roles = response.data.data;
          console.log('Roles data:', roles);
          this.loading = false;
          this.items = roles;
          this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);
        }
      } catch (error) {
        console.error('Error fetching user roles:', error);
        this.loading = false;
      }
    },

    backPageRoute() {
      this.$router.back();
    },

    createUser() {
      this.$router.push({ path: '/user-registration' });
    },

    toggleBothEdit() {
      let arr = Array.isArray(this.selectedUser) ? [...this.selectedUser] : [this.selectedUser].filter(Boolean);

      const hasWeb = arr.includes('Web User');
      const hasMobile = arr.includes('Mobile User');

      if (hasWeb && hasMobile) {
        arr = arr.filter(v => v !== 'Web User' && v !== 'Mobile User');
      } else {
        if (!hasWeb) arr.push('Web User');
        if (!hasMobile) arr.push('Mobile User');
      }
      this.selectedUser = arr;
    },

    // ==================== VIEW USER ROLE ====================
    openViewDialog(item) {
      const roleItem = this.extractTableRow(item);

      this.viewItem = {
        id: roleItem.id,
        role_type: roleItem.role_type,
        description: roleItem.description,
        category: roleItem.category,
        created_at: roleItem.created_at,
        accessDashboard: roleItem.accessDashboard || roleItem.access_dashboard || []
      };

      this.buildViewPermissionsTableForRole(roleItem);
      this.view_user_role_dialog = true;
      console.log('Viewing role:', this.viewItem);
    },

    buildViewPermissionsTableForRole(item) {
      const roleItem = this.extractTableRow(item);
      const roleDash = Array.isArray(roleItem?.accessDashboard)
        ? roleItem.accessDashboard
        : (Array.isArray(roleItem?.access_dashboard)
          ? roleItem.access_dashboard
          : (Array.isArray(roleItem?.dashboard) ? roleItem.dashboard : []));

      const normalizeModule = (name) => String(name || '').trim().toLowerCase().replace(/\s+/g, ' ');
      const toBool = (val) => Number(val) === 1;

      const permsByModule = new Map();
      roleDash.forEach(d => {
        const key = normalizeModule(d?.module);
        if (!key) return;

        const next = {
          read: toBool(d?.read_premission),
          write: toBool(d?.write_premission),
          delete: toBool(d?.delete_premission),
        };

        const prev = permsByModule.get(key);
        permsByModule.set(
          key,
          prev
            ? {
              read: prev.read || next.read,
              write: prev.write || next.write,
              delete: prev.delete || next.delete,
            }
            : next
        );
      });

      const getPerms = (title) => {
        const p = permsByModule.get(normalizeModule(title));
        return {
          read: !!p?.read,
          write: !!p?.write,
          delete: !!p?.delete,
        };
      };

      this.viewPermissionsItems = this.mainNavModules.map(nav => {
        if (nav.type === 'single') {
          return {
            ...nav,
            permissions: getPerms(nav.title),
          };
        }

        if (nav.type === 'group' && Array.isArray(nav.children)) {
          return {
            ...nav,
            children: nav.children.map(child => ({
              ...child,
              permissions: getPerms(child.title),
            })),
          };
        }

        return { ...nav };
      });
    },

    // Open edit dialog from view dialog
    openEditDialogFromView() {
      // Close the view dialog first
      this.view_user_role_dialog = false;

      // Create a temporary item from viewItem to pass to edit dialog
      const tempItem = {
        id: this.viewItem.id,
        role_type: this.viewItem.role_type,
        description: this.viewItem.description,
        category: this.viewItem.category,
        created_at: this.viewItem.created_at,
        accessDashboard: this.viewItem.accessDashboard
      };

      // Open the edit dialog
      this.openEditDialog(tempItem);
    },

    // Confirm delete from view dialog
    confirmDeleteFromView() {
      // Close the view dialog first
      this.view_user_role_dialog = false;

      // Create a temporary item from viewItem
      const tempItem = {
        id: this.viewItem.id,
        role_type: this.viewItem.role_type,
        description: this.viewItem.description,
        category: this.viewItem.category,
        created_at: this.viewItem.created_at,
        accessDashboard: this.viewItem.accessDashboard
      };

      // Open the delete confirmation dialog
      this.confirmDelete(tempItem);
    },
    // ==================== END VIEW USER ROLE ====================

    confirmDelete(item) {
      const roleItem = this.extractTableRow(item);

      if (this.isSuperAdminRole(roleItem?.role_type)) {
        this.showSnackbar('Super admin role cannot be deleted.', 'warning');
        return;
      }

      this.selectedItem = roleItem;
      this.deleteItemId = roleItem.id;
      this.deleteUserListDialog = true;
    },

    async deleteItem() {
      if (this.isSuperAdminRole(this.selectedItem?.role_type)) {
        this.deleteUserListDialog = false;
        this.deleteItemId = null;
        this.showSnackbar('Super admin role cannot be deleted.', 'warning');
        return;
      }

      if (this.hasAssociatedUsers(this.selectedItem)) {
        const userCount = this.getAssociatedUsersCount(this.selectedItem);
        const confirmMessage = `This role has ${userCount} associated user(s). Deleting it will remove access for these users. Are you sure you want to continue?`;
        if (!confirm(confirmMessage)) {
          this.deleteUserListDialog = false;
          return;
        }
      }

      this.centerLoading = true;
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const userRoleId = this.deleteItemId;

      try {
        const response = await axios.post(`/api/user/delete-role`, {
          userId,
          userRoleId
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.data.success) {
          this.deleteUserListDialog = false;
          this.deleteItemId = null;
          this.centerLoading = false;
          this.showSnackbar("The user role was successfully deleted", "success");
          await this.fetchUserRoles();
          await this.fetchAssociatedUsersCount();
        } else {
          console.error('Failed to delete the user role:', response.data);
          this.showSnackbar("Failed to delete user role.", "error");
        }
      } catch (error) {
        console.error('Error deleting user role:', error);
        this.deleteUserListDialog = false;
        this.showSnackbar("Error deleting user role.", "error");
      }
      this.centerLoading = false;
    },

    buildEditPermissionsTableForRole(item) {
      const roleItem = this.extractTableRow(item);
      const roleDash = Array.isArray(roleItem?.accessDashboard)
        ? roleItem.accessDashboard
        : (Array.isArray(roleItem?.access_dashboard)
          ? roleItem.access_dashboard
          : (Array.isArray(roleItem?.dashboard) ? roleItem.dashboard : []));

      const normalizeModule = (name) => String(name || '').trim().toLowerCase().replace(/\s+/g, ' ');
      const toBool = (val) => Number(val) === 1;

      const permsByModule = new Map();
      roleDash.forEach(d => {
        const key = normalizeModule(d?.module);
        if (!key) return;

        const next = {
          read: toBool(d?.read_premission),
          write: toBool(d?.write_premission),
          delete: toBool(d?.delete_premission),
        };

        const prev = permsByModule.get(key);
        permsByModule.set(
          key,
          prev
            ? {
              read: prev.read || next.read,
              write: prev.write || next.write,
              delete: prev.delete || next.delete,
            }
            : next
        );
      });

      const getPerms = (title) => {
        const p = permsByModule.get(normalizeModule(title));
        return {
          read: !!p?.read,
          write: !!p?.write,
          delete: !!p?.delete,
        };
      };

      this.editPermissionsItems = this.mainNavModules.map(nav => {
        if (nav.type === 'single') {
          return {
            ...nav,
            permissions: getPerms(nav.title),
          };
        }

        if (nav.type === 'group' && Array.isArray(nav.children)) {
          return {
            ...nav,
            children: nav.children.map(child => ({
              ...child,
              permissions: getPerms(child.title),
            })),
          };
        }

        return { ...nav };
      });
    },

    // Updated permission handler with proper logic (same as createuserrole)
    handleEditPermissionChange(permissionRow, permissionType) {
      if (!permissionRow?.permissions) return;

      const permissions = permissionRow.permissions;

      // When Read is toggled
      if (permissionType === 'read') {
        // If read is being unchecked, uncheck write and delete too
        if (!permissions.read) {
          permissions.write = false;
          permissions.delete = false;
        }
      }

      // When Write is toggled
      if (permissionType === 'write') {
        if (permissions.write) {
          // If write is checked, ensure read is checked
          permissions.read = true;
        }
        // If write is unchecked, we keep read as is (user might want read only)
      }

      // When Delete is toggled
      if (permissionType === 'delete') {
        if (permissions.delete) {
          // If delete is checked, ensure read is checked (need to view before deleting)
          // But we don't force write to be checked
          permissions.read = true;
        }
        // If delete is unchecked, we keep read and write as is
      }

      // Final validation: If read is false, ensure write and delete are false
      if (!permissions.read) {
        permissions.write = false;
        permissions.delete = false;
      }
    },

    resolveDashboardId(...candidates) {
      for (const value of candidates) {
        const parsed = Number(value);
        if (Number.isInteger(parsed) && parsed > 0) {
          return parsed;
        }
      }
      return null;
    },

    buildEditAccessDashboardPayload() {
      const rows = [];

      this.editPermissionsItems.forEach(item => {
        if (item.type === 'single') {
          const dashboardId = this.resolveDashboardId(item.dashboard_id);
          if (dashboardId !== null && (item.permissions.read || item.permissions.write || item.permissions.delete)) {
            rows.push({
              dashboard_id: dashboardId,
              module: item.title,
              read_premission: item.permissions.read ? 1 : 0,
              write_premission: item.permissions.write ? 1 : 0,
              delete_premission: item.permissions.delete ? 1 : 0,
            });
          }
        }
        else if (item.type === 'group' && item.children) {
          item.children.forEach(child => {
            const dashboardId = this.resolveDashboardId(child.dashboard_id, item.dashboard_id);
            if (dashboardId !== null && (child.permissions.read || child.permissions.write || child.permissions.delete)) {
              rows.push({
                dashboard_id: dashboardId,
                module: child.title,
                read_premission: child.permissions.read ? 1 : 0,
                write_premission: child.permissions.write ? 1 : 0,
                delete_premission: child.permissions.delete ? 1 : 0,
              });
            }
          });
        }
      });

      return rows.filter(r =>
        r.dashboard_id !== null &&
        (r.read_premission === 1 || r.write_premission === 1 || r.delete_premission === 1)
      );
    },

    getEnabledPermissionsWithoutDashboardId() {
      const missingModules = [];

      this.editPermissionsItems.forEach(item => {
        if (item.type === 'single') {
          const hasPermission = item.permissions.read || item.permissions.write || item.permissions.delete;
          const dashboardId = this.resolveDashboardId(item.dashboard_id);
          if (hasPermission && dashboardId === null) {
            missingModules.push(item.title);
          }
        } else if (item.type === 'group' && item.children) {
          item.children.forEach(child => {
            const hasPermission = child.permissions.read || child.permissions.write || child.permissions.delete;
            const dashboardId = this.resolveDashboardId(child.dashboard_id, item.dashboard_id);
            if (hasPermission && dashboardId === null) {
              missingModules.push(child.title);
            }
          });
        }
      });

      return missingModules;
    },

    openEditDialog(item) {
      const roleItem = this.extractTableRow(item);

      if (this.isSuperAdminRole(roleItem?.role_type)) {
        this.showSnackbar('Super admin role permissions are locked and cannot be edited.', 'warning');
        return;
      }

      this.isEditMode = true;
      this.selectedItem = roleItem;
      this.edit_user_role_dialog = true;

      this.roleForm.roleType = roleItem.role_type;
      this.roleForm.description = roleItem.description;
      const roleCategory = String(roleItem.category || '');
      this.selectedUser = roleCategory.includes(',')
        ? roleCategory.split(',').map(v => v.trim()).filter(Boolean)
        : roleCategory;

      this.buildEditPermissionsTableForRole(roleItem);

      console.log('Editing item:', roleItem);
      console.log('Role Form:', this.roleForm);
      console.log('Edit permissions:', this.editPermissionsItems);
    },

    updateUserRole() {
      if (this.isSuperAdminRole(this.selectedItem?.role_type || this.roleForm.roleType)) {
        this.showSnackbar('Super admin role permissions are locked and cannot be updated.', 'warning');
        return;
      }

      if (this.roleForm.roleType && this.roleForm.roleType.length > 20) {
        this.showSnackbar('Role type must be less than or equal to 20 characters.', 'error');
        return;
      }

      if (this.roleForm.description && this.roleForm.description.length > 300) {
        this.showSnackbar('Description must be less than or equal to 300 characters.', 'error');
        return;
      }

      this.centerLoading = true;
      const userId = parseInt(localStorage.getItem('userId'), 10);
      const token = localStorage.getItem('token');

      const missingDashboardModules = this.getEnabledPermissionsWithoutDashboardId();
      if (missingDashboardModules.length) {
        this.centerLoading = false;
        this.showSnackbar(`Missing dashboard_id for: ${missingDashboardModules.join(', ')}`, 'error');
        return;
      }

      let permissions = [];
      if (this.shouldShowPermissions()) {
        permissions = this.buildEditAccessDashboardPayload();
      }

      const payload = {
        userId,
        userRoleId: this.selectedItem.id,
        userRoleType: this.roleForm.roleType,
        userRoleDescription: this.roleForm.description,
        userRoleCategory: Array.isArray(this.selectedUser)
          ? this.selectedUser.join(", ")
          : this.selectedUser,
        permissions,
      };

      console.log('Payload to be sent:', JSON.stringify(payload, null, 2));

      axios.put('/api/user/edit-role', payload, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          console.log('User role updated:', response.data);
          this.fetchUserRoles();
          this.showSnackbar("User role permission Updated successfully!", "success");
          this.edit_user_role_dialog = false;
          this.centerLoading = false;
        })
        .catch(error => {
          console.error('Error updating user role:', error);
          this.centerLoading = false;
          if (error.response && error.response.data && error.response.data.message) {
            this.showSnackbar(error.response.data.message, "error");
          } else {
            this.showSnackbar("Error updating user role.", "error");
          }
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/user_management/user_role_list.scss" as *;

:deep(.v-data-table) {
  .description-text {
    display: inline-block;
    white-space: normal !important;
    word-break: break-word;
    line-height: 1.4;
  }

  td {
    vertical-align: middle;
  }
}

.permissions-table {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.permissions-head {
  display: flex;
  background-color: #f5f5f5;
  font-weight: bold;
  border-bottom: 2px solid #e0e0e0;

  .col-name {
    flex: 3;
    padding: 12px 16px;
  }

  .col-perm {
    flex: 1;
    padding: 12px 16px;
    text-align: center;
  }
}

.permissions-row {
  display: flex;
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }

  .col-name {
    flex: 3;
    padding: 10px 16px;
  }

  .col-perm {
    flex: 1;
    padding: 10px 16px;
    text-align: center;
  }
}

.custom_font_color_view {
  color: #2196F3 !important;
  font-weight: 500;
}

.super-admin-locked-text {
  color: #9E9E9E;
  font-style: italic;
  font-size: 12px;
}

// Edit and Delete button styles for view dialog
.custom_edit_btn {
  border-color: #4CAF50 !important;
  color: #4CAF50 !important;

  &:hover {
    background-color: rgba(76, 175, 80, 0.1) !important;
  }
}

.custom_delete_btn {
  border-color: #f44336 !important;
  color: #f44336 !important;

  &:hover {
    background-color: rgba(244, 67, 54, 0.1) !important;
  }
}
</style>